<template>
  <div class="BG_intelligentDecision" ref="BG_intelligentDecision">
    <div class="ulList" id="ulList">
      <div class="dutyStaticsBar" v-bind:key="i" v-for="(item, i) in dutyStaticsList">
        <div class="bar1">
          <div class="bar-title bar1-title">
            {{ item.warnType }}
          </div>
          <div class="bar-content bar1-content" @click="showCurrentDeviceRelateAreas(i)">
            {{ item.description }}
            <span style="display: block">{{ item.warnTime }}</span>
          </div>
        </div>
        <div class="bar2">
          <div class="bar-title bar2-title">
            {{ item.metric }}
          </div>
          <div class="bar-content number bar2-content">
            {{ item.value && item.value.toFixed(2) }}
            <!-- <span>{{ item.unit }}</span> -->
          </div>
        </div>
        <div class="bar3">
          <div class="bar3-content" v-if=" customerId != 36" @click="click1(item.deviceNo, i)">
            <span>污染排放溯源</span>
          </div>
          <div class="bar3-content" v-if=" customerId != 36" @click="click2(item.deviceNo, i)">
            <span>区域扩散分析</span>
          </div>
          <div class="bar3-content" @click="click3(item)">
            <span>智能决策建议</span>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center" v-show="noMoreData">暂无更多数据...</div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import moment from "moment";
import emissionSourceControll from "./emissionSourceControll";
import {
  LoadContaminatedAreaFun,
  EnterSelectModeFun,
  ExitSelectModeFun,
  HighlightAreaByIDFun,
  LoadContaminatedPointFun,
  ShowPointFun,
  ShowAreaLineFun,
  FocusAreaByIdFun,
  ClearAllEntityFun,
  CameraMove,
} from "@/assets/js/unity3D/index.js";
import { ElMessage } from "element-plus";
// var FocusData = {
//                 data:
//                     {
//                         "Id":"157",
//                         "time":"2.5"
//                     },
//             };
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      dutyStaticsList: [],
      curTicketNo: "",
      styleType: "",
      timer: null,
      pageNo: 1,
      noShakeTimer: null,
      noMoreData: false,
      timer2: null,
      currentAlarmDeviceNo: null,
      preAlarmAreas: null,
      nextAlarmAreas: null,
      currentAreas: null,
      intelligentMapObj: {},
    };
  },
  //计算属性 类似于data概念
  computed: {
    getColor() {
      return function (status) {
        let result = {};
        if (status === 0) {
          result = {
            color: "#F5A623",
          };
        } else if (status === 1) {
          result = {
            color: "#F5A623",
          };
        } else if (status === 2) {
          result = {
            color: "#30D594",
          };
        }
        return result;
      };
    },
  },
  //监控data中的数据变化
  watch: {
    currentAlarmDeviceNo(newValue) {
      // 当告警区域变化时，显示告警区域
      if (this.flag_selectAlram) {
        ClearAllEntityFun();
        let arr = this.showDeviceNoCurrentAreas(newValue);
        if (arr) {
          this.loadArea(arr);
        }
      }
    },
    "$store.state.intelligentMapObj": {
      handler(newVal, oldVal) {
        this.intelligentMapObj = newVal;
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = bmeConfig.styleType;
    this.intelligentMapObj = this.$store.state.intelligentMapObj;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  async mounted() {
    let that = this;
    let w = $(that.$refs.BG_intelligentDecision).outerWidth();
    let h = $(that.$refs.BG_intelligentDecision).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    await this.getData(1);
    this.$nextTick(() => {
      this.scrollAll();
    });
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  beforeUnmount() {
    let tableBody = $(".BG_intelligentDecision")[0];
    tableBody.removeEventListener("scroll", this.initHeight);
    this.$store.state.currentAreaId = null;
    if (this.$store.state.titleViews == "智能联动" && this.customerId == "38") {
      ClearAllEntityFun();
      ExitSelectModeFun();
    }
  },
  //方法集合
  methods: {
    scrollAll() {
      let that = this;
      let tableBody = $(".BG_intelligentDecision")[0];
      tableBody.addEventListener("scroll", that.initHeight);
    },
    initHeight() {
      let that = this;
      if (that.noShakeTimer) {
        clearTimeout(that.noShakeTimer);
      }
      let tableBody = $(".BG_intelligentDecision")[0];
      // 滚动距离
      let scrollTop = tableBody.scrollTop;
      // 变量windowHeight是可视区的高度
      let windowHeight = tableBody.clientHeight;
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = tableBody.scrollHeight;
      console.log(scrollTop, windowHeight, scrollHeight);
      if (scrollTop + windowHeight + 100 > scrollHeight) {
        that.noShakeTimer = setTimeout(() => {
          that.pageNo++;
          that.getData();
        }, 200);
      }
    },
    async getData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      let districtInfoUrl = CONFIG.requestName + this.$apiOpt.districtInfo;
      // let districtInfoUrl =
      //   "http://screen.bmetech.com/screen/alarm/district/info";
      let res = await this.$apiUtils.get(districtInfoUrl, {
        customerId: this.customerId,
        pageNo: this.pageNo,
        pageSize: 100,
        // startTime: "2021-12-25 21:20:44",
        startTime: moment(new Date().getTime() - 60 * 60 * 24 * 1000).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        endTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        // endTime: "2021-12-25 23:20:44",
      });
      if (res) {
        if (
          res.records === undefined ||
          res.records === null ||
          res.records?.length === 0
        ) {
          this.noMoreData = true;
          let tableBody = $(".BG_intelligentDecision")[0];
          tableBody.removeEventListener("scroll", this.initHeight);
        } else {
          this.dutyStaticsList = [...this.dutyStaticsList, ...res.records];
          if (this.$store.state.titleViews == "智能联动" && this.customerId == "38") {
            await this.getAreaList();
            await this.getEmissions();
            this.setAlarmInfos(this.dutyStaticsList);
            if (!this.currentAlarmDeviceNo) {
              this.showCurrentDeviceRelateAreas(0);
            }
          }
        }
      }
      this.timer = setTimeout(() => {
        this.pageNo = 1;
        this.dutyStaticsList = [];
        this.noMoreData = false;
        this.getData();
        this.scrollAll();
      }, 60000 * 5);
    },
    async getBuildingId1(deviceNo) {
      //污染排放溯源
      let retrogressiveUrl = CONFIG.requestName + this.$apiOpt.retrogressive;
      // let retrogressiveUrl =
      //   "http://screen.bmetech.com/screen/alarm/retrogressive";
      let res = await this.$apiUtils.get(retrogressiveUrl, {
        deviceNo: deviceNo, //"XH822CX20102200225"
      });
      if (res) {
        console.log("res.data", res);
        return res;
      }
    },
    async getBuildingId2(deviceNo) {
      //区域扩散分析
      let diffusionUrl = CONFIG.requestName + this.$apiOpt.diffusion;
      // let diffusionUrl = "http://screen.bmetech.com/screen/alarm/diffusion";
      let res = await this.$apiUtils.get(diffusionUrl, {
        deviceNo: deviceNo, //"XH822CX20102200225" ||
      });
      if (res) {
        console.log("res.data", res);
        return res;
      }
    },
    async getBuildingId3(item) {
      //智能建议
      let suggestUrl = CONFIG.requestName + this.$apiOpt.suggest;
      // let suggestUrl = "http://screen.bmetech.com/screen/alarm/suggest";
      let res = await this.$apiUtils.get(suggestUrl, {
        customerId: this.customerId, //66
        deviceNo: item.deviceNo, //"XH822CX20102200225"
        metric: item.metric, //"TSP"
        eventType: item.eventType, //1
      });
      if (res) {
        console.log("res.data", res);
        return res;
      }
    },
    createMask(id) {
      let info = this.intelligentMapObj[id];
      if (info && info.pos && info.pos.length > 0) {
        let json2 = {
          ref: `alert_${id}`,
          czmObject: {
            xbsjType: "Polygon",
            enabled: false,
            xbsjGuid: "a7a97abc-455e-4f3f-a54a-d6efb5c220a4",
            name: info.name,
            positions: info.pos,
            height: 0,
            extrudedHeight: null,
            show: false,
            outline: {},
            ground: true,
          },
        };
        g_bme3dManager?.earth?.sceneTree?.$refs?.bgAlertPower?.children.push(json2);

        let json = {
          ref: id,
          czmObject: {
            xbsjType: "Polygon",
            enabled: false,
            xbsjGuid: "a7a97abc-455e-4f3f-a54a-d6efb5c220a4",
            name: info.name,
            positions: info.pos,
            height: 0,
            extrudedHeight: null,
            show: false,
            outline: {},
            ground: true,
          },
        };
        let json3 = {
          ref: `poi_${id}`,
          czmObject: {
            xbsjType: "GeoPin",
            enabled: false,
            xbsjGuid: "d2e7f492-887a-45a7-af65-293a131d221a",
            name: info.name,
            evalString: "",
            position: [info.pos[0], info.pos[1], 50],
            far: 1073741824,
            innerHTML: `<!DOCTYPE HTML>\n<html>\n\n<head>\n    <title></title>\n    <style>\n        .textContain {\n            position: absolute;\n            height: 38px;\n            background-color: rgba(0, 0, 0, 0.8);\n            box-shadow: 0px 8px 16px 0px rgba(74, 144, 226, 0.31);\n            \nborder-radius: 2px;\nborder: 1px solid #4A90E2;\n            padding: 5px 10px ;\n            line-height:28px;\n            white-space: nowrap;\n            top: -15px;\n            left: -50px;\n            font-size: 18px;\n            border:0;      \n            color: #F5A623;\n        }\n    </style>\n</head>\n<body>\n    <div class="textContain">${info.name}</div>\n</body>\n\n</html>`,
          },
        };
        g_bme3dManager?.earth?.sceneTree?.$refs?.bgPower?.children.push(json, json3);
        return g_bme3dManager.earth.sceneTree.$refs[id];
      } else {
        return null;
      }
    },
    changeColor(res, key1, key2) {
      this.closeAllColor();
      let currentBuild = g_bme3dManager.earth.sceneTree.$refs[key1];
      if (!currentBuild) {
        currentBuild = this.createMask(key1);
      }
      if (currentBuild) {
        currentBuild.enabled = true;
        currentBuild.czmObject.color = bmeConfig.bg_mark_color.markColor.online;
        currentBuild.czmObject.outline.color =
          bmeConfig.bg_mark_color.markOutColor.online;
        // currentBuild.czmObject.flyTo()
      }
      key2 &&
        key2.forEach((item) => {
          let retrogressiveItem = g_bme3dManager.earth.sceneTree.$refs[item];
          if (!retrogressiveItem) {
            retrogressiveItem = this.createMask(item);
          }
          if (retrogressiveItem) {
            retrogressiveItem.enabled = true;
            retrogressiveItem.czmObject.color =
              bmeConfig.bg_mark_color.markColor.nextMark;
            retrogressiveItem.czmObject.outline.color =
              bmeConfig.bg_mark_color.markOutColor.nextMark;
          }
        });
    },
    closeAllColor() {
      if (this.customerId != 38) {
        let buildGroup = g_bme3dManager?.earth?.sceneTree?.$refs?.bgPower?.children;
        buildGroup &&
          buildGroup.forEach((item) => {
            item.enabled = false;
          });
        window.currentODlineArr =
          window.currentODlineArr && window.currentODlineArr.destroy();
      }
    },
    async click1(deviceNo, index) {
      if (this.$store.state.titleViews != "智能联动" || this.customerId != "38") {
        let res = await this.getBuildingId1(deviceNo);
        if (res) {
          this.changeColor(res, res.current, res.retrogressive);
          this.dealODlineData(res.current, res.retrogressive);
          if (this.timer2) {
            clearTimeout(this.timer2);
            this.timer2 = null;
          }
          this.timer2 = setTimeout(() => {
            this.closeAllColor();
          }, 5 * 1000);
        }
      } else {
        this.showPreAreas(this.currentAlarmDeviceNo);
        this.$store.state.currentAreaId = this.currentAlarmDeviceNo + "|pre";
      }
    },
    async click2(deviceNo, index) {
      if (this.$store.state.titleViews != "智能联动" || this.customerId != "38") {
        let res = await this.getBuildingId2(deviceNo);
        if (res) {
          this.changeColor(res, res.current, res.diffusion);
          this.dealODlineData(res.current, res.diffusion);
          let deviceInfo = {
            deviceNo,
            desc: res.desc,
          };
          this.$store.commit("changeDiffusionAnalysisDeviceInfo", deviceInfo);
        }
      } else {
        this.showNextAreas(this.currentAlarmDeviceNo);
        this.$store.state.currentAreaId = this.currentAlarmDeviceNo + "|next";
      }
    },
    async click3(item) {
      if (this.$store.state.titleViews != "智能联动" || this.customerId != "38") {
        window.currentODlineArr =
          window.currentODlineArr && window.currentODlineArr.destroy();
        let res = await this.getBuildingId3(item);
        if (res) {
          this.changeColor(res, res.districtId);
          let suggestInfo = {
            deviceNo: item.deviceNo,
            suggest: res.suggest,
          };
          this.$store.commit("changeIntelligentSuggestInfo", suggestInfo);
        }
      } else {
        let suggest = await this.getBuildingId3(item);
        if (suggest.suggest) {
          ElMessage.info(suggest.suggest);
        }
      }
    },
    async dealODlineData(current, nextArr) {
      let p1 = this.getMapIdPos(current);
      let getAllDataArr = [];
      getAllDataArr.push(p1);

      nextArr &&
        nextArr.forEach((item) => {
          let p_child = this.getMapIdPos(item);
          getAllDataArr.push(p_child);
        });
      let res = await Promise.all(getAllDataArr);
      let ODlineData = {
        current: {},
        next: [],
      };
      window.currentODlineArr =
        window.currentODlineArr && window.currentODlineArr.destroy();
      if (res) {
        if (res[0]) {
          ODlineData.current = res[0];

          if (res[0].longitude && res[0].latitude) {
            let positionArr = [
              (res[0].longitude * 2 * Math.PI) / 360,
              (res[0].latitude * 2 * Math.PI) / 360,
              100,
            ];
            window.g_bme3dManager.earth.camera.flyTo(
              positionArr,
              2500,
              [0.783968080355887, -1.5044151748284547, 0.03280222548769185],
              2
            );
          }

          res.shift();
          res.forEach((item) => {
            ODlineData.next.push(item);
          });
          window.currentODlineArr = this.createODLines(ODlineData);
        }
      }
    },
    async getMapIdPos(id) {
      let getMapIdPosUrl = CONFIG.requestName + this.$apiOpt.getMapIdPos;
      return this.$apiUtils.get(getMapIdPosUrl, {
        customerId: this.customerId,
        districtId: id,
      });
    },
    createODLines(ODlineData) {
      let odlineDealData = [];
      if (
        !ODlineData?.current?.longitude ||
        !ODlineData?.current?.latitude ||
        !ODlineData?.next?.length
      )
        return;
      ODlineData.next.forEach((item) => {
        if (!item.longitude || !item.latitude) {
          return true;
        }
        odlineDealData.push([
          [
            (ODlineData.current.longitude * Math.PI) / 180,
            (ODlineData.current.latitude * Math.PI) / 180,
            0,
          ],
          [(item.longitude * Math.PI) / 180, (item.latitude * Math.PI) / 180, 0],
        ]);
      });
      // console.log("odlineDealData", odlineDealData);
      let earth = g_bme3dManager.earth;
      const odlines = new XE.Obj.ODLines(earth);
      odlines.color = [1, 1, 1, 1];

      var busLines = [];

      var p = odlineDealData;

      var positionsCollection = p.map((e) => {
        const toDegree = 180.0 / Math.PI;
        // Cesium.xbsjCreateTransmitPolyline 根据 首末端点生成弧线，
        // 参数有：
        // startPosition, 端点1
        // endPosition, 端点2
        // minDistance, 计算出的线段的最小间隔距离
        // heightRatio=1.0 弧线高度抬升程度，值越大，抬高得越明显
        // 返回值是cartesian类型的坐标数组
        const cartesians = Cesium.xbsjCreateTransmitPolyline(e[0], e[1], 50.0, 5.0);
        const poss = cartesians.map((ee) => {
          const carto = Cesium.Cartographic.fromCartesian(ee);
          return [carto.longitude, carto.latitude, carto.height];
        });

        return poss;
      });
      positionsCollection.push(...positionsCollection);
      //positionsCollection.push(...positionsCollection);

      let timeDuration = 10.0;
      let moveBaseDuration = 4.0;

      busLines = positionsCollection.map((e) => {
        return {
          positions: e,
          color: [0.5, 0.8, 1.0, 5.0],
          width: 5.0,
          startTime: timeDuration * Math.random(),
          duration: moveBaseDuration + 1.0 * Math.random(),
        };
      });

      odlines.data = busLines;
      odlines.timeDuration = timeDuration;
      odlines.playing = true;

      return odlines;
    },
    /*------------------永钢二期排放源开始---------------------------*/
    setAlarmInfos(alarms) {
      alarms.forEach((alarm) => {
        if (alarm.districtList && alarm.districtList.length > 0) {
          alarm.districtList.forEach((alarmData) => {
            emissionSourceControll.setAreasByDeviceNo(
              {
                current: [alarmData.current],
                pre: alarmData.retrogressive,
                next: alarmData.diffusion,
              },
              alarm.deviceNo + "|" + alarmData.current
            );
          });
        }
      });
    },
    // 获取所有区域经纬度数据
    async getAreaList() {
      //获取区域列表
      let url = CONFIG.requestName + this.$apiOpt.getAreaList;
      const params = {
        customerId: this.customerId,
      };
      let res = await this.$apiUtils.get(url, params);
      if (res) {
        emissionSourceControll.setAreas(res);
      }
    },
    async getEmissions() {
      let emissionUrl = CONFIG.requestName + this.$apiOpt.getAllEmission;
      let res = await this.$apiUtils.get(emissionUrl, {
        customerId: this.customerId,
      });
      if (res) {
        emissionSourceControll.setEmissionList(res);
      } else {
        return false;
      }
    },
    // 点击告警信息，显示告警区域
    showCurrentDeviceRelateAreas(index) {
      this.flag_selectAlram = true;
      this.currentAlarmDeviceNo = this.dutyStaticsList[index].deviceNo;
      this.$store.state.currentAreaId = this.currentAlarmDeviceNo + "|current";
    },
    //显示告警信息的所有区域和区域内的排放源
    showDeviceNoCurrentAreas(deviceNo, tip = "current") {
      let currentareaIds = emissionSourceControll.getRelationAreas(deviceNo, tip);
      if (currentareaIds) {
        let arr = [];
        currentareaIds.forEach((areaId, index) => {
          let currentArea = emissionSourceControll.getAreaInfoById(areaId.id);
          if (
            arr.findIndex((item) => {
              return item.id == currentArea[0].id;
            }) == -1
          ) {
            arr = arr.concat(currentArea);
          }
          // this.showAreaAndEmissions(areaId.id,(index == currentareaIds.length - 1));
        });
        return arr;
      } else {
        return false;
      }
    },
    // 显示区域和区域内的排放源
    showAreaAndEmissions(areaId) {
      let points = {
        data: [],
        flag: true,
      };
      let areaEmissions = emissionSourceControll.getEmissionsByAreaId(areaId);
      if (areaEmissions) {
        areaEmissions.forEach((item, index) => {
          points.data.push({
            id: item.id,
            color: "#00EB64",
            customerId: 38,
            device: null,
            downstreamEmissionInfo: null,
            emissionType: item.emissionType,
            latitude: item.latitude * 1,
            level: 2,
            longitude: item.longitude,
            mapId: item.mapId.toString(),
            name: item.name,
            parentProcessId: 96,
            processName: "混匀工段",
            sortId: index,
          });
        });
        LoadContaminatedPointFun(points);
        // EnterSelectModeFun();
        areaEmissions.forEach((item) => {
          ShowPointFun(item.id.toString());
        });
      } else {
        // EnterSelectModeFun();
      }
    },
    // 显示上游区域
    showPreAreas(deviceNo) {
      ClearAllEntityFun();
      let arr1 = this.showDeviceNoCurrentAreas(deviceNo);
      let arr2 = this.showDeviceNoCurrentAreas(deviceNo, "pre");
      if (arr2) {
        let arr = arr1.concat(arr2);
        this.loadArea(arr);
      } else {
        this.loadArea(arr1);
      }
      setTimeout(() => {
        this.showRelationLines(deviceNo, "pre");
      }, 1000);
    },
    // 显示下游区域
    showNextAreas(deviceNo) {
      ClearAllEntityFun();
      let arr1 = this.showDeviceNoCurrentAreas(deviceNo);
      let arr2 = this.showDeviceNoCurrentAreas(deviceNo, "next");
      if (arr2) {
        let arr = arr1.concat(arr2);
        this.loadArea(arr);
      } else {
        this.loadArea(arr1);
      }
      setTimeout(() => {
        this.showRelationLines(deviceNo, "next");
      }, 1000);
    },
    // 显示区域引导线
    showRelationLines(deviceNo, tip) {
      let lines = emissionSourceControll.getAreaRelationsByAreaId(deviceNo, tip);
      if (lines) {
        lines.forEach((line) => {
          ShowAreaLineFun(line);
        });
      }
    },
    loadArea(arr) {
      setTimeout(() => {
        LoadContaminatedAreaFun({ data: arr, flag: true });
        EnterSelectModeFun();
        arr.forEach((area) => {
          this.showAreaAndEmissions(area.id);
        });
      }, 1000);
    },
    /*------------------永钢二期排放源结束---------------------------*/
  },
};
</script>
<style lang="scss" scoped>
.BG_intelligentDecision {
  position: absolute;
  height: 710px;
  width: 100%;
  margin-top: 65px !important;
  padding: 0px 32px !important;
  pointer-events: all;
  overflow: auto;
  .dutyStaticsBar {
    position: relative;
    width: 100%;
    display: flex;
    background: rgba(0, 0, 0, 0.8);
    margin: 10px 0;
    border: 1px solid #8badff;
    &:hover {
      box-shadow: 1px 1px 30px #fff !important;
      background: rgb(0, 0, 0) !important;
      border: 2px solid #fff !important;
    }
    .bar1 {
      width: calc(100% - 257px);
    }
    .bar2 {
      width: 137px;
    }
    .bar3 {
      width: 120px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      align-content: center;
    }
  }

  .bar-title {
    display: block;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
  }
  .bar-content {
    display: block;
    height: 100px;
    padding: 10px 10px;
  }
  .bar1-title {
    font-family: "normalFont";
    font-size: 18px;
    color: rgba(153, 192, 255, 1);
    padding: 0px 15px;
    border-right: 1px solid #99c0ff;
    border-bottom: 1px solid #99c0ff;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    span {
      float: right;
      color: rgba(200, 221, 225, 1);
    }
  }

  .bar1-content {
    color: #c6c6c6;
    font-family: "normalFont";
    font-size: 18px;
    padding: 10px 15px;
    border-right: 1px solid #99c0ff;
    cursor: pointer;
    &:hover {
      background: #3467e4;
      border-radius: 2px;
      color: white;
    }
  }

  .bar2-title {
    font-family: "normalFont";
    font-size: 18px;
    color: #99c0ff;
    padding: 0px 15px;
    border-right: 1px solid #99c0ff;
    border-bottom: 1px solid #99c0ff;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .bar2-content {
    color: #ffffff;
    font-family: "normalFont";
    font-size: 26px;
    padding: 15px 5px;
    border-right: 1px solid #99c0ff;
    align-items: center;
    display: flex;
    justify-content: center;
    span {
      display: block;
      font-size: 16px;
      line-height: 16px;
      font-family: "normalFont" !important;
      color: #c6c6c6;
    }
  }

  .bar3-content {
    color: #c6c6c6;
    font-family: "normalFont";
    font-size: 16px;
    text-align: center;
    background: rgba(52, 103, 228, 0.2);
    border-radius: 2px;
    height: 34px;
    width: 120px;
    color: rgba(66, 245, 212, 1);
    position: relative;
    cursor: pointer;
    span {
      line-height: 34px;
    }
    &:hover {
      background: #3467e4;
      border-radius: 2px;
      span {
        color: white;
      }
    }
  }
}
</style>
